module.exports = __webpack_public_path__ + "img/img-3400@2x.42ec4ed1.jpg";